<template>
  <VueDatePicker v-bind="mergedAttrs" :clearable="false" placeholder="">
    <template #input-icon>
      <img src="@/assets/img/calendar-days-solid.svg" class="dp__input_icons" />
    </template>
    <template v-for="(_, name) in $slots" v-slot:[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
  </VueDatePicker>
</template>

<script>
import { VueDatePicker } from "@vuepic/vue-datepicker";

export default {
  name: "AppDatePicker",
  components: { VueDatePicker },
  inheritAttrs: false,
  computed: {
    mergedAttrs() {
      // Ensure a default timezone of 'utc' unless explicitly provided
      return { ...this.$attrs, timezone: this.$attrs.timezone || "utc" };
    },
  },
};
</script>

<style lang="scss">
.dp__calendar_item {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
